import * as Flex from "@twilio/flex-ui";
import { ConversationState, styled, Actions } from "@twilio/flex-ui";
import { Stack } from "@twilio/flex-ui/node_modules/@twilio-paste/core";
import { useState, useEffect } from "react";
import {
  checkAndRemoveOldInvitedParticipants,
  countOfOutstandingInvitesForConversation
} from "../../helpers/inviteTracker";
import {
  CancelChatParticipantInviteActionPayload,
  RemoveChatParticipantActionPayload
} from "../../types/ActionPayloads";
import { InvitedParticipantDetails } from "../../types/InvitedParticipantDetails";
import { ParticipantDetails } from "../../types/ParticipantDetails";
import { InviteParticipant } from "./InviteParticipant/InviteParticipant";
import { InvitedParticipants } from "./InvitedParticipants/InvitedParticipants";
import { Participants } from "./Participants.tsx/Participants";
import { getUpdatedParticipantDetails, getUpdatedInvitedParticipantDetails } from "./hooks";

const ParticipantsTabContainer = styled.div`
  padding-left: 3%;
  padding-right: 3%;
  padding-top: 3%;
  width: 100%;
`;

interface ParticipantsTabProps {
  task: Flex.ITask;
  conversation: ConversationState.ConversationState;
}

export const ParticipantsTab = ({ task, conversation }: ParticipantsTabProps) => {
  const [participantDetails, setParticipantDetails] = useState<ParticipantDetails[]>([]);
  const [invitedParticipantDetails, setInvitedParticipantDetails] = useState<InvitedParticipantDetails[]>([]);
  const [disableNewInvites, setDisableNewInvites] = useState<boolean>(false);

  useEffect(() => {
    const updateParticipants = () => {
      getUpdatedParticipantDetails(task, conversation, participantDetails).then((participantDetails) => {
        if (participantDetails) setParticipantDetails(participantDetails);
      });
    };

    const updateInvitedParticipants = () => {
      checkAndRemoveOldInvitedParticipants(Flex.Manager.getInstance(), task, conversation);
    };

    updateParticipants();
    updateInvitedParticipants();
    setInvitedParticipantDetails(getUpdatedInvitedParticipantDetails(conversation));

    // for now just allow one outstanding invite to simplify routing. conversation.attribute.invites supports muliple though
    if (countOfOutstandingInvitesForConversation(conversation)) setDisableNewInvites(true);
    else setDisableNewInvites(false);
  }, [conversation, participantDetails, task]);

  const conversationSid = task.attributes?.conversations?.conversation_id || task.taskSid;
  const handleKickParticipant = (interactionParticipantSid: string) => {
    const payload: RemoveChatParticipantActionPayload = {
      conversationSid,
      task,
      interactionParticipantSid
    };
    Actions.invokeAction("RemoveChatParticipant", payload);
  };

  const handleCancelInvite = (invitedParticipantDetails: InvitedParticipantDetails) => {
    const payload: CancelChatParticipantInviteActionPayload = {
      conversation,
      invitesTaskSid: invitedParticipantDetails.invitesTaskSid
    };
    Actions.invokeAction("CancelChatParticipantInvite", payload);
  };

  return (
    <ParticipantsTabContainer>
      <Stack orientation="vertical" spacing="space40">
        <Participants participantDetails={participantDetails} handleKickParticipant={handleKickParticipant} />

        <InvitedParticipants
          invitedParticipantDetails={invitedParticipantDetails}
          handleCancelInvite={handleCancelInvite}
        />

        <InviteParticipant task={task} disableNewInvites={disableNewInvites} />
      </Stack>
    </ParticipantsTabContainer>
  );
};
